import { DOCUMENT, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Directive, Inject, HostListener, NgModule } from '@angular/core';

class ScrollToDirective {
    constructor(document, elRef, zone) {
        this.document = document;
        this.elRef = elRef;
        this.zone = zone;
    }
    scrollTo(event) {
        this.zone.runOutsideAngular(() => {
            event.preventDefault();
            if (!this.elRef.nativeElement || !this.elRef.nativeElement.hash) {
                return;
            }
            const hash = decodeURIComponent(this.elRef.nativeElement.hash);
            const elem = this.document.querySelector(hash);
            if (elem) {
                elem.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
                let nullTabIndex = false;
                if (!elem.getAttribute('tabindex')) {
                    nullTabIndex = true;
                    elem.setAttribute('tabindex', -1);
                }
                elem.focus({ preventScroll: true });
                setTimeout(() => {
                    elem.blur();
                    if (nullTabIndex) {
                        elem.removeAttribute('tabindex');
                    }
                });
            }
        });
    }
}
ScrollToDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ScrollToDirective, deps: [{ token: DOCUMENT }, { token: i0.ElementRef }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Directive });
ScrollToDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: ScrollToDirective, selector: "[uprScrollTo]", host: { listeners: { "click": "scrollTo($event)" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ScrollToDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[uprScrollTo]'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.ElementRef }, { type: i0.NgZone }]; }, propDecorators: { scrollTo: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class ScrollToModule {
}
ScrollToModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ScrollToModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
ScrollToModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ScrollToModule, declarations: [ScrollToDirective], imports: [CommonModule], exports: [CommonModule, ScrollToDirective] });
ScrollToModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ScrollToModule, imports: [[CommonModule], CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: ScrollToModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    declarations: [ScrollToDirective],
                    exports: [CommonModule, ScrollToDirective]
                }]
        }] });

export { ScrollToDirective, ScrollToModule };
